import { B as BUILD, C as CSS, p as plt, w as win, a as promiseResolve, b as bootstrapLazy } from './index-bfb2bce5.js';
export { s as setNonce } from './index-bfb2bce5.js';
import { g as globalScripts } from './app-globals-0f993ce5.js';

/*
 Stencil Client Patch Esm v3.1.0 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    // NOTE!! This fn cannot use async/await!
    // TODO(STENCIL-659): Remove code implementing the CSS variable shim
    // @ts-ignore
    if (BUILD.cssVarShim && !(CSS && CSS.supports && CSS.supports('color', 'var(--c)'))) {
        // @ts-ignore
        return import(/* webpackChunkName: "polyfills-css-shim" */ './css-shim-6210ce77.js').then(() => {
            if ((plt.$cssShim$ = win.__cssshim)) {
                // TODO(STENCIL-659): Remove code implementing the CSS variable shim
                return plt.$cssShim$.i();
            }
            else {
                // for better minification
                return 0;
            }
        });
    }
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  globalScripts();
  return bootstrapLazy([["ttui-release-note",[[1,"ttui-release-note",{"releaseTitle":[1,"release-title"],"releaseVersion":[1,"release-version"],"releaseDate":[1,"release-date"],"markdownContent":[1,"markdown-content"],"scope":[1]}]]],["ttui-stt-controls",[[1,"ttui-stt-controls",{"sttQueue":[4,"stt-queue"],"buttonText":[32],"results":[32]}]]],["ttui-content-image",[[1,"ttui-content-image",{"src":[1],"alt":[1]}]]],["ttui-badge",[[1,"ttui-badge"]]],["ttui-button",[[1,"ttui-button"]]],["ttui-card",[[1,"ttui-card"]]],["ttui-container",[[1,"ttui-container"]]],["ttui-metadata",[[1,"ttui-metadata"]]],["ttui-separator",[[1,"ttui-separator"]]],["ttui-typography",[[1,"ttui-typography",{"ttuiTitle":[4,"ttui-title"],"ttuiSubtitle":[4,"ttui-subtitle"],"ttuiSmall":[4,"ttui-small"]}]]]], options);
  });
};

export { defineCustomElements };

//# sourceMappingURL=loader.js.map